import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Card, Container, Skeleton, Subheading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import { EmployesTile } from './products/Employes';
import { NmbrsTile } from './products/Nmbrs';
import { LoketTile } from './products/Loket';
import { AfasTile } from './products/Afas';
import { SlackTile } from './products/Slack';
import { useTranslation } from 'react-i18next';
import { SDWorxTile } from './products/SDWorx';
import { HoorayTile } from './products/Hooray';
import { YouServeTile } from './products/YouServe';
import { HR2DayTile } from './products/HR2Day';

const Contents = styled(Container)`
	height: 100%;
	background: ${(props) => props.theme.colors.whiteBlue};
`;

const Grid = styled(Box)`
	display: grid;
	grid-gap: 20px;
	grid-template-columns: repeat(auto-fit, 240px);
`;

export default function Marketplace() {
	const { t } = useTranslation();
	const { data } = graphql.useMarketplaceQuery();
	const { data: slackData } = graphql.useSlackConfigQuery();

	return (
		<Contents>
			<Subheading pt={4}>{t('settings.connectors.marketplace.hris')}</Subheading>

			<Grid pt={3} pb={4}>
				{data ? (
					<>
						<AfasTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Afas}
						/>
						<EmployesTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Employes}
						/>
						<HoorayTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Hooray}
						/>
						<LoketTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Loket}
						/>
						<NmbrsTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Nmbrs}
						/>
						<SDWorxTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Cobra}
						/>
						<YouServeTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Youserve}
						/>
						<HR2DayTile
							selected={data.viewer.workspace.connector?.type === graphql.ConnectorType.Hr2Day}
						/>
					</>
				) : (
					<Skeleton.Repeat count={3}>
						<Card.Skeleton height={200} />
					</Skeleton.Repeat>
				)}
			</Grid>

			<Subheading pt={3}>{t('settings.connectors.marketplace.messaging')}</Subheading>
			<Grid pt={3} pb={4}>
				{slackData ? (
					<SlackTile selected={slackData?.viewer.workspace.slackConfig?.isConfigured ?? false} />
				) : (
					<Skeleton.Repeat count={3}>
						<Card.Skeleton height={200} />
					</Skeleton.Repeat>
				)}
			</Grid>
		</Contents>
	);
}
